module.exports = __webpack_public_path__ + "img/LA.ac7e695a.svg";